import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

@Component({
  selector: 'app-meet-our-team',
  template: `
    <section>
      <h3>{{ 'meet_team.title' | translate }} <span>{{ 'meet_team.subtitle' | translate }}</span></h3>
      <div class="team-members">
        <div class="team-member">
          <img src="assets/images/team/member1.jpg" alt="Team Member">
          <h4>John Doe</h4>
          <p>Senior Agent</p>
        </div>
        <div class="team-member">
          <img src="assets/images/team/member2.jpg" alt="Team Member">
          <h4>Jane Smith</h4>
          <p>Property Consultant</p>
        </div>
        <div class="team-member">
          <img src="assets/images/team/member3.jpg" alt="Team Member">
          <h4>Mike Johnson</h4>
          <p>Sales Manager</p>
        </div>
      </div>
    </section>
  `,
  styles: [`
    section {
      padding: 2rem 0;
      text-align: center;
    }

    h3 {
      font-size: 2rem;
      margin-bottom: 1rem;
      color: var(--ion-color-dark);

      span {
        display: block;
        font-size: 1rem;
        color: var(--ion-color-medium);
        margin-top: 0.5rem;
      }
    }

    .team-members {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;
      margin-top: 2rem;
    }

    .team-member {
      background: var(--ion-color-light);
      border-radius: 8px;
      padding: 1rem;
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      img {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: 1rem;
      }

      h4 {
        margin: 0;
        color: var(--ion-color-dark);
      }

      p {
        margin: 0.5rem 0 0;
        color: var(--ion-color-medium);
      }
    }
  `],
  imports: [
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true
})
export class MeetOurTeamComponent implements OnInit {
  @Input() agents!: any[] | undefined;
  ngOnInit() {
    // Initialize any required logic here
  }
}
